<div class="leaderboard-container" [class.margin-y-10]="isLoading">
  <ng-container *ngIf="isLoading; else leaderBoard">
    <uni-loader></uni-loader>
  </ng-container>
  
  <ng-template #leaderBoard>
    <ng-container *ngIf="leaderboardEntries.length > 0; else noEntries">
      <uni-leaderboard
        [leaderboardEntries]="leaderboardEntries"
        [shortlistedAnnounced]="shortlistedAnnounced"
        [resultsAnnounced]="resultsAnnounced"
        [host]="host">
      </uni-leaderboard>
    </ng-container>
    <ng-template #noEntries>
      <div fxLayout="row" fxLayoutAlign="center center" class="height-50vh">
        No entries have been submitted yet.
      </div>
    </ng-template>

  </ng-template>
</div>